import { KeyValue } from "@/main/models/common";
import { SubModelRequest } from "@/main/models/request";
import { IInitialReducerData } from "@/main/services/reducerUtils";

export enum SubModelTypes {
	GET_SUBMODELS = "@subModel/GET_SUBMODELS",
	SAVE_SUBMODELS = "@subModel/SAVE_SUBMODELS",
	RESET_REDUCER_SUBMODELS = "@subModel/RESET_REDUCER_SUBMODELS",
}

export interface SubModelState {
	readonly subModels: {
		data: KeyValue[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
	readonly isolated: {
		[key: string]: IInitialReducerData;
	};
}

export interface GetSubModels {
	type: typeof SubModelTypes.GET_SUBMODELS;
	payload: {
		request: SubModelRequest;
		keyReducer: string;
	};
}

export interface SaveSubModels {
	type: typeof SubModelTypes.SAVE_SUBMODELS;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
		keyReducer: string;
	};
}

export interface ResetReducerSubModels {
	type: typeof SubModelTypes.RESET_REDUCER_SUBMODELS;
	payload: {
		keyReducer: string;
	};
}

export type SubModelActionTypes = GetSubModels | SaveSubModels | ResetReducerSubModels;
